import moment from "moment";

export const getQueryStringParams = (): {
  [key: string]: string
} => {
  const arr = window.location.search?.replace(/^\?/, "").split("#")[0].split("&");
  let _parametri: {
    [key: string]: string
  } = {};
  for (let i = 0; i < arr.length; i++) {
    let param = arr[i].split("=");
    _parametri[param[0]] = param.length > 0 ? param[1] : "";
  }
  return _parametri;
};

export const dateFormat = (date: Date | null | undefined): string => {
  return date ? moment(date).format('DD-MM-YYYY') : '-';
}

export const timeFormat = (date: Date | null | undefined): string => {
  return date ? moment(date).format('HH:mm') : '-';
}

export const dateTimeFormat = (date: Date | null | undefined): string => {
  return date ? moment(date).format('DD-MM-YYYY HH:mm') : '-';
}

export const dateWithTime = (date: Date, dayMoment: "start" | "end"): Date => {
  const noTime = new Date(date);
  switch (dayMoment) {
    case "start":
      noTime.setUTCHours(0, 0, 0, 0);
      break;
    case "end":
      noTime.setUTCHours(23, 59, 59, 999);
      break;
  }
  return noTime;
}

export const onKeyPress = (evt: any, skipRegexText?: boolean, regex?: RegExp) => {
  var theEvent = evt || window.event;
  let key;
  // Handle paste
  if (theEvent.type === 'paste') {
    key = evt.clipboardData.getData('text/plain');
  } else {
    // Handle key press
    key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  var _regex = regex || /[0-9]|\./;
  if (!skipRegexText && !_regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export const handleBlobResponse = (response: any, type?: string, fileName?: string, open?: boolean) => {
  var newBlob = new Blob([response], { type: type || "application/unknown" })
  if (typeof ((window.navigator as any).msSaveOrOpenBlob) === "function") {
    (window.navigator as any).msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const a = document.createElement("a");
  a.setAttribute('href', data);
  if (!open && fileName) {
    a.setAttribute('download', fileName);
  } else {
    a.setAttribute('target', '_blank');
  }
  a.click();
};